import { graphql } from 'react-apollo';

import { AlbumForWebGalleriesAllPhotos } from '../../../../../../web-gallery/graphql/queries/album';

const AlbumForWebGalleriesAllPhotosOptions = {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumMembershipGroupId,
      use_all_photos_mode: true,
    },
    fetchPolicy: 'cache-and-network',
  }),
  skip: ({ match }) => !match.params.albumMembershipGroupId,
};
const getAlbumForWebGalleriesAllPhotos = graphql(
  AlbumForWebGalleriesAllPhotos,
  AlbumForWebGalleriesAllPhotosOptions,
);

export default getAlbumForWebGalleriesAllPhotos;
